/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import TableCell from 'src/components/Table/TableCell';
import { formatAmount } from 'src/utils/formatAmout';
import OverflowTipography from 'src/components/OverflowTipography';
import { capitalizeName } from 'src/utils/common';

const AgingBalanceRow = ({
  clientId,
  clientFullname,
  contractId,
  folio,
  overdue_1_30,
  overdue_31_60,
  overdue_61_90,
  overdue_91_120,
  overdue_over_120,
  totalOverdue,
  showFolio,
  upToDateBalance
}) => {
  return (
    <TableRow hover>
      {showFolio && (
        <TableCell align="center" sx={{ fontWeight: 'bold' }}>
          <Link to={`/contracts/${contractId}`}>
            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '1.43'
              }}
            >
              {folio}
            </Typography>
          </Link>
        </TableCell>
      )}

      <TableCell align="left">
        <OverflowTipography title={capitalizeName(clientFullname)}>
          <Link to={`/clients/detail/${clientId}`}>
            {capitalizeName(clientFullname)}
          </Link>
        </OverflowTipography>
      </TableCell>
      <TableCell align="center" sx={{ fontWeight: 'bold' }}>
        {formatAmount(totalOverdue)}
      </TableCell>
      <TableCell align="center">{formatAmount(upToDateBalance)}</TableCell>
      <TableCell align="center">{formatAmount(overdue_1_30)}</TableCell>
      <TableCell align="center">{formatAmount(overdue_31_60)}</TableCell>
      <TableCell align="center">{formatAmount(overdue_61_90)}</TableCell>
      <TableCell align="center">{formatAmount(overdue_91_120)}</TableCell>
      <TableCell align="center">{formatAmount(overdue_over_120)}</TableCell>
    </TableRow>
  );
};

AgingBalanceRow.propTypes = {
  clientId: PropTypes.number.isRequired,
  clientFullname: PropTypes.string.isRequired,
  contractId: PropTypes.number,
  folio: PropTypes.string,
  upToDateBalance: PropTypes.number.isRequired,
  overdue_1_30: PropTypes.number.isRequired,
  overdue_31_60: PropTypes.number.isRequired,
  overdue_61_90: PropTypes.number.isRequired,
  overdue_91_120: PropTypes.number.isRequired,
  overdue_over_120: PropTypes.number.isRequired,
  totalOverdue: PropTypes.number.isRequired,
  showFolio: PropTypes.bool
};

AgingBalanceRow.defaultProps = {
  contractId: null,
  folio: '',
  showFolio: false
};

export default AgingBalanceRow;
